import { supabase } from "~/integrations/supabase/client";

import type { PublishedMoveLine } from "~/types/contabilidad";

export interface DiarioFilters {
  dateFrom: string;
  dateTo: string;
  companyId?: string;
  journalId?: string;
  accountId?: string;
  accountCodeFrom?: string;
  accountCodeTo?: string;
}

// PostgREST caps a single response at db-max-rows (10k on this project). A wide
// date range easily exceeds that, so we page through the result set and rely on
// the function's deterministic ORDER BY (…, aml.id) for stable pagination.
const PAGE_SIZE = 5000;

export const diarioService = {
  async getPublishedMoveLines(
    filters: DiarioFilters
  ): Promise<PublishedMoveLine[]> {
    const params = {
      p_date_from: filters.dateFrom,
      p_date_to: filters.dateTo,
      p_company_id: filters.companyId || null,
      p_journal_id: filters.journalId || null,
      p_account_id: filters.accountId || null,
      p_account_code_from: filters.accountCodeFrom || null,
      p_account_code_to: filters.accountCodeTo || null,
    };

    const all: PublishedMoveLine[] = [];
    for (let from = 0; ; from += PAGE_SIZE) {
      const { data, error } = await supabase
        .rpc("get_published_move_lines", params)
        .range(from, from + PAGE_SIZE - 1);

      if (error) throw error;

      const batch = (data ?? []) as PublishedMoveLine[];
      all.push(...batch);
      if (batch.length < PAGE_SIZE) break;
    }

    return all;
  },
};
